import { z } from "zod";

export type GenericCollectionReference = {
  id: string;
  path: string;
  parent: GenericDocumentReference | null;
};

export type GenericDocumentReference = {
  id: string;
  path: string;
  parent: GenericCollectionReference | null;
};

export type IReference = z.infer<typeof TReference>;
export const TReference: z.ZodType<
  GenericCollectionReference | GenericDocumentReference
> = z.object({
  id: z.string(),
  path: z.string(),
  parent: z.lazy(() => TReference.or(z.null())),
});

export type IRelativeExternalData = z.infer<typeof TRelativeExternalData>;
export const TRelativeExternalData = z.object({
  apiClientID: z.string(),
  type: z.string(),
  id: z.string(),
});

export type IRelative = z.infer<typeof TRelative>;
export const TRelative = z.object({
  external: TRelativeExternalData.optional(),
  name: z.string().optional(),
  type: z.number().optional(),
  reference: z.optional(z.lazy(() => TReference)).or(z.string()),
  path: z.string().optional(),
});

export type IRelatives = z.infer<typeof TRelatives>;
export const TRelatives = z.record(z.string(), TRelative);

/**
 * @deprecated Use `IRelative` instead.
 */
export type IApiRelative = z.infer<typeof TApiRelative>;
/**
 * @deprecated Use `TRelative` instead.
 */
export const TApiRelative = z.object({
  name: z.string().optional(),
  type: z.number().optional(),
  reference: z.string().optional(),
});

/**
 * @deprecated Use `IRelatives` instead.
 */
export type IApiRelatives = z.infer<typeof TApiRelatives>;
/**
 * @deprecated Use `TRelatives` instead.
 */
export const TApiRelatives = z.record(z.string(), TApiRelative);
